export const containerPrimaryVariantsCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
});
export const containerSecondaryVariantsCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    border_radius: FOUNDATIONS.radius_1000,
    background_color: FOUNDATIONS.color_neutral_bg_600,
    width: 'fit-content',
    padding: FOUNDATIONS.spacing_150,
});
//# sourceMappingURL=commonStyles.js.map